import script from "./TagTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TagTableItem.vue?vue&type=script&setup=true&lang=js"

import "./TagTableItem.vue?vue&type=style&index=0&id=5041fc74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5041fc74"]])

export default __exports__